module.exports = __webpack_public_path__ + "themes/mf/img/button@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/button@2x.png
// module id = 70
// module chunks = 3